import { IPendoConfig } from '@assess/browser/pendo';

import { environment } from '../../environments/environment';

export const pendoConfig: IPendoConfig = environment.pendo;
